/**
 * Ink it — Tokens de diseño (espejo JS de las variables CSS de index.css).
 *
 * Úsalos en estilos inline, `react-select`, MUI (`sx`) y componentes JS.
 * No escribas hex sueltos en los componentes. Documentación: /STYLES.md
 *
 * Los colores neutros apuntan a las variables CSS (`var(--ink-*)`) para que
 * sigan el tema (claro/oscuro). La marca y los estados son fijos.
 */
export const theme = {
    // Primary (verde de marca)
    primary: '#7FBB23',
    primaryRgb: '127, 187, 35',
    primaryHover: '#70a51f',
    primaryActive: '#5f8f1a',
    primarySoft: 'rgba(127, 187, 35, 0.12)',
    primaryContrast: '#ffffff',

    // Secondary (gris)
    secondary: '#6c757d',
    secondaryRgb: '108, 117, 125',
    secondaryHover: '#5c636a',

    // Dark y superficies (siguen el tema)
    bg: 'var(--ink-bg)',
    dark: 'var(--ink-dark)',
    darkRgb: 'var(--ink-dark-rgb)',
    surface: 'var(--ink-surface)',
    surface2: 'var(--ink-surface-2)',
    surface3: 'var(--ink-surface-3)',
    surfaceRaised: 'var(--ink-surface-raised)',
    elevated: 'var(--ink-elevated)',
    inputBg: 'var(--ink-input-bg)',

    // Bordes (siguen el tema)
    border: 'var(--ink-border)',
    borderStrong: 'var(--ink-border-strong)',
    borderSoft: 'var(--ink-border-soft)',

    // Neutros / texto (siguen el tema)
    text: 'var(--ink-text)',
    textSecondary: 'var(--ink-text-secondary)',
    textMuted: 'var(--ink-text-muted)',
    textDim: 'var(--ink-text-dim)',
    textDisabled: 'var(--ink-text-disabled)',
    disabled: 'var(--ink-disabled)',

    // Estados
    success: '#198754',
    successRgb: '25, 135, 84',
    successSoft: 'rgba(25, 135, 84, 0.18)',
    danger: '#dc3545',
    dangerRgb: '220, 53, 69',
    dangerText: '#f87171',
    dangerSoft: 'rgba(220, 53, 69, 0.18)',
    warning: '#ffc107',
    warningRgb: '255, 193, 7',
    warningAlt: '#fd7e14',
    info: '#7FBB23',
    infoRgb: '127, 187, 35',
};

export default theme;
